import { useQuery } from "react-query";
import { api } from "utils/api";
import { submissionKeys } from "./queryKeys";
import type { SubmissionsForVotingResp } from "../types";

const getSubmissionsForCuration = (openCallId?: string, curatorId?: string) => {
  if (!openCallId) {
    Promise.reject(new Error("Invalid open call id."));
  }
  if (!curatorId) {
    Promise.reject(new Error("Invalid magic link for partner curation."));
  }
  return api.get<SubmissionsForVotingResp>(
    `/open-call/partner-voting/${openCallId}/submissions?id=${curatorId}`,
  );
};

const useSubmissionsForCuration = (openCallId?: string, curatorId?: string) =>
  useQuery(
    submissionKeys.curation(openCallId, curatorId),
    () => getSubmissionsForCuration(openCallId, curatorId),
    {
      // Don't start until the open call is loaded and we have a curator id magic link
      enabled: !!openCallId && !!curatorId,
      // NOTE: Never refetch, it will rearrange the values because they're randomized on the backend
      staleTime: Infinity,
    },
  );

export { useSubmissionsForCuration };
